export const TextDescription = {
    TEXT_ONE: '•\tBuild front-end WPA (ES2018, CSS3, Ajax) through appealing mobile-ready responsive UI/UX design\n' +
        '•\tWrite effective APIs with security with NodeJS\n' +
        '•\tTest software to ensure responsiveness and efficiency with Jest\n' +
        '•\tDeploy the application into AWS EC2 and S3\n' +
        '•\tWrite technical documentation\n' +
        '•\tTroubleshoot, debug and upgrade software\n',
    TEXT_TWO: '●\tWrite the model, data migration, and seed data by using TypeORM and MySQL\n' +
        '●\tDesigned and implemented the system’s routes and Restful APIs\n' +
        '●\tImplemented the RBAC (Role based access control), supported role and permission assignment and access\n' +
        '●\tResearch, design, evaluate and implement the cross-platform deployment solutions\n' +
        '●\tOptimize the application for maximum performance and scalability\n' +
        '●\tBuild front-end WPA (ES2018, CSS3, Ajax) through appealing mobile-ready responsive UI/UX design\n' +
        '●\tWrite effective APIs with security with NodeJS\n' +
        '●\tTest software to ensure responsiveness and efficiency with Jest\n' +
        '●\tDeploy the application into AWS EC2 and S3\n' +
        '●\tWrite technical documentation\n',
    TEXT_THREE: '●\tCreating an e-commerce furniture platform SPA by using React, React-Redux, Redux-Form, with (Express + NodeJS) as REST API backend to talk to database (MySQL)\n' +
        '●\tDeveloped data driven dynamic applications for rendering full accessible user interfaces\n' +
        '●\tFollowed responsive and mobile first rules to design layout and components\n' +
        '●\tCreated various components and using React Hook and universal store using Redux\n' +
        '●\tDemonstrated graphs, tables using third party libraries such as React Hook Form\n' +
        '●\tIntegrated online payment channel of PayPal Restful API\n' +
        '●\tCommunicate with back-end such as search, get, post etc. using Fetch and Axios\n' +
        '●\tIntegrated user management through JWT token\n'

}


export const TITLE = {
    TITLE_ONE: 'Mark2win Official Website',
    TITLE_TWO: 'Management System',
    TITLE_THREE: 'Herman miller' + '\n' + 'furniture e-commerce online shopping mall'
}


export const API = {
    API_MARK2WIN: 'https://i.ibb.co/WchvYP3/Mark2win2.png',
    API_CHAIR: 'https://i.ibb.co/8j3FDZS/chair3.png',
    API_SYSTEM: 'https://i.ibb.co/f2JtGKM/processed-2d588d65-5369-492f-9fff-6437b468fbdf-Wx-X0f-A9l.jpg',
    MARK_WRB: 'https://mark2win.com/',
    CHAIR:'http://mfs.mark2win.com/'
}

export const MAIN_DESCRIPTION = {
    TITLE: 'Hello, I am Qisen Wang',
    SECOND_TITLE: 'I am a Front End Developer',
    CONTEXT: 'I have four years experience with REACT, REDUX, NEXT JS and Node JS',
    SEC_CONTEXT: 'Looking for a position as a Front End Developer, React Developer',
    TITLE_UP: 'Yes !',
    FIRST_UP: 'This is me !',
    SEC_UP: 'But I am a little bit shy.... Only Shows up when you call me.'
}


export const ABOUT = {
    EDUCATION: 'Education',
    NAME: 'ALGONQUIN COLLEGE',
    PROGRAM: 'Advanced Diploma – Computer\n' +
        'Engineering Technology\n',
    SKILL: '●\tFront-end: JavaScript(3yrs), MVVM, TypeScript(2yrs), SSR, JSON, React/Redux/Hook(3yrs), NextJS(1yrs), HTML5(2yrs), CSS3(2yrs), SCSS, Webpack, Bootstrap, jQuery, Material UI, Restful API, Middleware, JWT\n' +
        '\n' +
        '●\tBackend:  NodeJS(2yrs), C#,C++,Java, Express, .net, cross-env, CORS, AWS EC2, S3, API Gateway, Lambda\n' +
        '\n' +
        '\n' +
        '●\tDatabase: Oracle DB, Redis, Modeling, MySQL, Oracle, MongoDB, DDL, DML, DQL, DCL\n' +
        '\n' +
        '●\tProject Management: Agile, JIRA, NPM, GitHub, Git Bash, GitLab, SVN, Linux\n',
    QUALIFICATION: 'HIGHLIGHTS OF QUALIFICATIONS',
    DETAILS: '●\tExcellent knowledge of Cloud, VS Code, Linux, Bash, Git/GitHub, Microsoft Office \n' +
        '●\t2+ Proven experience with front-end development (ES2018 JavaScript, React, Java, C#).\n' +
        '●\tPassion in Software development especially Front-End and Full-Stack development\n' +
        '●\tA highly motivated, hard-working, and pleasant team player.\n' +
        '●\tHands-on experience of modern web development technical stacks.\n',
    SUM: 'Solutions driven Computer Programmer experienced and passionate about ' +
        'developing customized solutions that improve processes and add value to users. ' +
        'Graduate of Computer Engineering Technology whose academic credentials are reinforced by hands on programming experience. ' +
        'Seeking a position as a full-time employment opportunity in Software Development, React Development, ' +
        'Full-Stack Web Development.'

}

export const EXPERIENCE = {
    FIRST_POSITION: 'Full Stack Developer, Mark2Win IT Solutions – Toronto\t  02/2021 - Present',
    FIRST_DETAILS: 'Related skills: Html5, CSS3, React, Redux, Redux-Form, Bootstrap, Material UI, TypeScript, NodeJS',
    DETAIL_TITLE: 'Projects (Working in a team of 6 members):',
    FIRST_PROJECT: '1.\tLearning Management System\n' +
        '●\tWrite the model, data migration, and seed data by using TypeORM and MySQL\n' +
        '●\tDesigned and implemented the system’s routes and Restful APIs\n' +
        '●\tImplemented the RBAC (Role based access control), supported role and permission assignment and access\n' +
        '●\tResearch, design, evaluate and implement the cross-platform deployment solutions\n' +
        '●\tOptimize the application for maximum performance and scalability\n' +
        '●\tBuild front-end WPA (ES2018, CSS3, Ajax) through appealing mobile-ready responsive UI/UX design\n' +
        '●\tWrite effective APIs with security with NodeJS\n' +
        '●\tTest software to ensure responsiveness and efficiency with Jest\n' +
        '●\tDeploy the application into AWS EC2 and S3\n' +
        '●\tWrite technical documentation\n',
    SEC_PROJECT: '2.\tHerman miller furniture e-commerce online shopping mall\n' +
        '●\tCreating an e-commerce furniture platform SPA by using React, React-Redux, Redux-Form, with (Express + NodeJS) as REST API backend to talk to database (MySQL)\n' +
        '●\tDeveloped data driven dynamic applications for rendering full accessible user interfaces\n' +
        '●\tFollowed responsive and mobile first rules to design layout and components\n' +
        '●\tCreated various components and using React Hook and universal store using Redux\n' +
        '●\tDemonstrated graphs, tables using third party libraries such as React Hook Form\n' +
        '●\tIntegrated online payment channel of PayPal Restful API\n' +
        '●\tCommunicate with back-end such as search, get, post etc. using Fetch and Axios\n' +
        '●\tIntegrated user management through JWT token\n',

    SEC_POSITION: 'Front-end developer, Yonge Solutions Tech Inc.\t    05/2018– 09/2020',
    SEC_TITLE: 'Write the global css3 files for the WordPress template.',
    SEC_DETAILS: '•\tBuild front-end WPA (ES2018, CSS3, Ajax) through appealing mobile-ready responsive UI/UX design\n' +
        '•\tWrite effective APIs with security with NodeJS\n' +
        '•\tTest software to ensure responsiveness and efficiency with Jest\n' +
        '•\tDeploy the application into AWS EC2 and S3\n' +
        '•\tWrite technical documentation\n' +
        '•\tTroubleshoot, debug and upgrade software\n'

}

export const PROFILE_ACTION = {
    BOTTOM_CONTROL:'BOTTOM_CONTROL',
    SEC_BOTTOM_CONTROL:'SEC_BOTTOM_CONTROL'
}







